import { createContext, useContext, useState, useCallback } from "react";
import { STRINGS } from "../lib/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("sparkle_lang") || "az");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "az" ? "en" : "az";
      localStorage.setItem("sparkle_lang", next);
      return next;
    });
  }, []);

  const t = useCallback((key) => STRINGS[lang][key] || STRINGS.az[key] || key, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
